import { Box, BoxProps, Button, DialogActions, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import DisplayEmptyListAction from "../../../../../../../components/DisplayEmptyListAction";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import { useState } from "react";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DialogAddRetencao from "./DialogAddRetencao";
import { TitPagarRetencao } from "../../../../../../../types/api/financeiro/detalhar-titulo-pagar";
import tratativaDeDatas from "../../../../../../../helpers/tratativaDeDatas";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { usePermission } from "../../../../../../../components/PermissionGuard";

export default function RetencaoDetalhe({
    codigo,
    valores,
    valorTotal,
    boxStyle
}: RetencaoDetalheProps) {
    const [openSelect, setOpenSelect] = useState<boolean>(false);

    //valores importantes
    const podeEditar = usePermission('financeiro.contas-receber-editar')
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    const Actions = () => (
        <Stack direction="row" gap={2}>
            <Button
                variant="outlined"
                size="small"
                startIcon={<AttachMoneyIcon />}
                onClick={() => setOpenSelect(true)}
                disabled={valorTotal === 0}
            >
                Adicionar retenção
            </Button>
        </Stack>
    )
    //

    return (
        <Box {...boxStyle}>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Typography variant="h6">Retenção</Typography>
                {
                    (podeEditar && !(!valores || valores?.length === 0)) &&
                    <Stack direction="row" justifyContent="flex-end">
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<EditOutlinedIcon />}
                            sx={{ fontSize: '0.75rem' }}
                            onClick={() => setOpenSelect(true)}
                        >
                            Editar
                        </Button>
                    </Stack>
                }
            </DialogActions>
            {
                (!valores || valores?.length === 0) &&
                <>
                    <DisplayEmptyListAction
                        label="Nenhum valor retido. Deseja adicionar?"
                        actionSection={<Actions />}
                    />
                </>
            }
            {
                openSelect &&
                <DialogAddRetencao
                    {...{ codigo, valorTotal }}
                    detalhe={valores}
                    open={openSelect}
                    handleClose={() => setOpenSelect(false)}
                />
            }

            {
                (valores && valores.length > 0) &&
                <>
                    <TableContainer>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={paddingStyle}><b>Retenção</b></TableCell>
                                    <TableCell sx={paddingStyle}><b>Vencimento</b></TableCell>
                                    <TableCell sx={paddingStyle} align="right"><b>Valor</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {valores.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell sx={paddingStyle} component="th" scope="row">
                                            {`${row.retencao.codigo} - ${row.retencao.descricao}`}
                                        </TableCell>
                                        <TableCell>{tratativaDeDatas(row.vencimento_retencao)}</TableCell>
                                        <TableCell sx={paddingStyle} align="right">{formatarValorMonetario(row.valor_retencao)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
        </Box>
    )
}

interface RetencaoDetalheProps {
    codigo: string
    valores: TitPagarRetencao[]
    boxStyle: BoxProps
    valorTotal: number
}
